module.exports = __webpack_public_path__ + "static/media/mysql.8f6fa9a1.png";